import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CatalogueService } from '../catalogue/catalogue.service';
import { ExhitorsService } from '../exhitors/exhitors.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilsService } from '../utils/utils.service';

@Component({
  selector: 'app-modal-import-exhibitor',
  templateUrl: './modal-import-exhibitor.component.html',
  styleUrls: ['./modal-import-exhibitor.component.scss']
})
export class ModalImportExhibitorComponent implements OnInit, OnDestroy {

  copyData = {
    exhibitorId: false,
    products: {},
  };

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  openIndex: number | null = null;
  selectIndex: boolean | null = false;

  @Input() importData: Array<any> = [];
  @Input() exhibitorId: string|null = '';
  @Input() sapId: string|null = '';

  constructor(public catalogueService: CatalogueService, private exhitorsService: ExhitorsService, private ngbActiveModal: NgbActiveModal,
    private utilsService: UtilsService
  ){
    this.copyData = {
      exhibitorId: false,
      products: {},
    };
  }

  editCopyExhibitorAndProducts(editCopyExhibitorAndProductsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.editCopyExhibitorAndProducts(Number(this.exhibitorId), editCopyExhibitorAndProductsIn)
      .subscribe((data: object) => {
        this.editCopyExhibitorAndProductsOk(data);
      },
        error => {
          this.editCopyExhibitorAndProductsError(error);
        });

  }

  editCopyExhibitorAndProductsOk(data) {

    this.loader.count--;
    this.importData = data;

  }

  editCopyExhibitorAndProductsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  close() {
    this.ngbActiveModal.close();
  }

  toggleExhibitors(index: number) {
    this.openIndex = this.openIndex === index ? null : index;
  }
  
  getImage(exhibitor:any) {
    return exhibitor.mainImage || '/assets/img/no_image_available.png';
  }
  
  getProductImage(product:any) {
    return product.mainImageUrl || '/assets/img/no_image_available.png';
  }

  _api(transition, property){
    return this.utilsService._api(transition, property);
  }
  
  toggleDisplay(item:any) {
    item.isDisplayed = !item.isDisplayed;
  }

  
  onProductChange(product:any, isChecked:boolean, modelChange:boolean = false) {
    if(isChecked) {
      this.copyData.products[product.id] = true;
    } else if (!isChecked) {
      delete this.copyData.products[product.id];
    }
    if (modelChange) product.isSelected = isChecked;
  }
  onProductChangeCheck(product:any, $event:any) {
    this.onProductChange(product, $event.target.checked);
  }

  
  onExhibitorChange(exhibitor:any, isChecked:boolean) {
    if(isChecked) {
      this.copyData.exhibitorId = exhibitor.id;
    } else if (this.copyData.exhibitorId === exhibitor.id && !isChecked) {
      this.copyData.exhibitorId = false;
    }
  }
  onExhibitorChangeCheck(exhibitor:any, $event:any) {
    this.onExhibitorChange(exhibitor, $event.target.checked);
  }

  setOption(option) {
    this.ngbActiveModal.close({
      id: this.copyData.exhibitorId,
      productsIds: Object.keys(this.copyData.products)
    });
  }

  ngOnInit(): void {
    

    let editCopyExhibitorAndProductsIn = {
      exhibitorId: this.exhibitorId,
      sapId: this.sapId
    }

    //this.editCopyExhibitorAndProducts(editCopyExhibitorAndProductsIn);


  }

  ngOnDestroy(): void {
    
  }

}
